import React from 'react';
import Message from '../Common/Message';

const IdentityError = () => <Message content='An error in communication with the Identity Server happend' />;

export default IdentityError;
